import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../../../../environments/environment';
import { PersonGenderService } from '../../../../services/person-genders/person-gender.service';
import { ReportService } from '../../../../services/reports/report.service';
import { LightboxModule } from 'ngx-lightbox';
import { EmployeesComponent } from './employees.component';
import { FuseAddorEditEmployeeComponent } from './components/add-employee/add-employee.component';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { JobTitleService } from '../../../../services/jobtitle/jobtitle.service';
import { TypeEmployeeService } from '../../../../services/type-employee/type-employee.service';
import { EmployeeExcelConfigurationComponent } from './components/employee-excel-configuration/employee-excel-configuration.component';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { TeacherAttendanceSheetConfigurationComponent } from './components/teacher-attendance-sheet-configuration/teacher-attendance-sheet-configuration.component';
import { ClipboardModule } from 'ngx-clipboard';
import { EmployeeMailConfigurationComponent } from './components/employee-mail-configuration/employee-mail-configuration.component';
import { MedicalLetterEmployeeModule } from '../medical-letter/medical-letter-employee.module';
import { IndexCardConfigurationComponent } from '../configurations/index-card-configuration/index-card-configuration.component';
import { IndexCardConfigurationModule } from '../configurations/index-card-configuration/index-card-configuration.module';
import { IndexCardConfigurationService } from '../../../../services/index-card-configuration/index-card-configuration.service';
import { EmployeeIndexCardConfigurationComponent } from './components/employee-index-card-configuration/employee-index-card-configuration.component';
import { EmployeeScheduleDialogComponent } from './components/employee-schedule-dialog/employee-schedule-dialog.component';
import { SubjectScheduleDialogComponent } from './components/subject-schedule-dialog/subject-schedule-dialog.component';

const routes = [
    {
        path: 'pages/management/employees/:id',
        component: EmployeesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EMPLOYEE',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/employees',
        component: EmployeesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EMPLOYEE',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/employees/:id',
        component: EmployeesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EMPLOYEE',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        EmployeesComponent,
        FuseAddorEditEmployeeComponent,
        EmployeeExcelConfigurationComponent,
        TeacherAttendanceSheetConfigurationComponent,
        EmployeeMailConfigurationComponent,
        EmployeeIndexCardConfigurationComponent,
        EmployeeScheduleDialogComponent,
        SubjectScheduleDialogComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        ClipboardModule,
        LightboxModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        }),
        MedicalLetterEmployeeModule,
        IndexCardConfigurationModule
    ],
    exports: [
        EmployeesComponent,
        EmployeeMailConfigurationComponent
    ],
    entryComponents: [
        FuseAddorEditEmployeeComponent,
        EmployeeExcelConfigurationComponent,
        TeacherAttendanceSheetConfigurationComponent,
        EmployeeMailConfigurationComponent,
        EmployeeIndexCardConfigurationComponent,
        EmployeeScheduleDialogComponent,
        SubjectScheduleDialogComponent
    ],
    providers: [
        EmployeeService,
        PersonGenderService,
        JobTitleService,
        TypeEmployeeService,
        ReportService,
        IndexCardConfigurationService
    ]
})

export class FuseEmployeeModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/employees.module.ts